import React from 'react';
import WithPicLayout from '../layout/WithPicLayout';

const AboutMeSection = ({ differentiators, image, imagePosition = 'left' }) => {
  return (
    <WithPicLayout image={image} imagePosition={imagePosition}>
      <div>
        {differentiators.map((diff, index) => (
          <p key={index}>
            <strong>{diff.title}</strong>{' '}
            {diff.content}
          </p>
        ))}
      </div>
    </WithPicLayout>
  );
};

export default AboutMeSection;